import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Lock, LogIn, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export const AdminLoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from || "/admin";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(username, password);
      toast.success("Καλώς ήρθες!");
      nav(from, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Λάθος στοιχεία");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      className="min-h-[80vh] flex items-center justify-center px-6 py-16"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-white mb-6"
        >
          <ArrowLeft size={14} /> Πίσω στο site
        </Link>

        <div className="bg-[#050505] border border-white/5 rounded-3xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 rounded-xl bg-[#B026FF]/10 text-[#B026FF]">
              <Lock size={20} />
            </div>
            <div>
              <div className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-bold">
                Admin
              </div>
              <h1 className="font-heading text-2xl font-bold">Σύνδεση Διαχειριστή</h1>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-testid="admin-login-form">
            <label className="flex flex-col gap-2">
              <span className="text-xs text-zinc-400 font-medium">Username</span>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="neon-input"
                autoComplete="username"
                data-testid="admin-login-username"
              />
            </label>
            <label className="flex flex-col gap-2">
              <span className="text-xs text-zinc-400 font-medium">Κωδικός</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="neon-input"
                autoComplete="current-password"
                data-testid="admin-login-password"
              />
            </label>

            <button
              type="submit"
              disabled={submitting}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#B026FF] text-black px-6 py-3.5 rounded-lg font-bold hover:neon-box-glow-pink transition-all disabled:opacity-40"
              data-testid="admin-login-submit"
            >
              {submitting ? "Σύνδεση..." : (<><LogIn size={16} /> Είσοδος</>)}
            </button>
          </form>
        </div>
      </div>

      <style>{`
        .neon-input {
          width: 100%;
          background: #0A0A0A;
          border: 1px solid rgba(255,255,255,0.08);
          color: white;
          padding: 0.75rem 1rem;
          border-radius: 0.5rem;
          font-size: 0.9rem;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .neon-input:focus {
          border-color: #B026FF;
          box-shadow: 0 0 0 1px #B026FF;
        }
      `}</style>
    </main>
  );
};

export default AdminLoginPage;
